/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Order Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export interface CommonErrorUnauthorizedError {
    'code': CommonErrorUnauthorizedErrorCodeEnum;
    'message': string;
}

export enum CommonErrorUnauthorizedErrorCodeEnum {
    MissingAuthenticationToken = 'MISSING_AUTHENTICATION_TOKEN',
    AccessDenied = 'ACCESS_DENIED',
    Unauthorized = 'UNAUTHORIZED',
    OrganizationNotFound = 'ORGANIZATION_NOT_FOUND',
    InvalidTokenFormat = 'INVALID_TOKEN_FORMAT',
    JwtClaimValidationFailed = 'JWT_CLAIM_VALIDATION_FAILED',
    JwtExpired = 'JWT_EXPIRED',
    JoseAlgNotAllowed = 'JOSE_ALG_NOT_ALLOWED',
    JoseNotSupported = 'JOSE_NOT_SUPPORTED',
    JweDecryptionFailed = 'JWE_DECRYPTION_FAILED',
    JweInvalid = 'JWE_INVALID',
    JwsInvalid = 'JWS_INVALID',
    JwtInvalid = 'JWT_INVALID',
    JwksNoMatchingKey = 'JWKS_NO_MATCHING_KEY',
    JwsSignatureVerificationFailed = 'JWS_SIGNATURE_VERIFICATION_FAILED'
}


